

const AboutAction = () => {
    return (
        <div className="w-full h-full flex flex-wrap justify-center items-center">
            <div className="w-full lg:w-[655px] h-auto xl:h-[35px] justify-center xl:justify-start items-center gap-2 xl:gap-[120px] inline-flex">
                <div className="h-auto xl:h-[35px] justify-center lg:justify-start items-center gap-5 flex flex-col lg:flex-row">

                    <div className="lg:w-[460px] flex-col justify-center items-center lg:items-start gap-5 inline-flex">
                        <div className="self-stretch justify-center items-center gap-5 inline-flex">
                            <div className="grow shrink basis-0 text-white text-[10px] lg:text-base font-semibold font-['Open Sans'] text-center lg:text-left ">Лицензионное соглашение с конечным пользователем</div>
                        </div>
                    </div>
                    <div className="h-auto xl:h-[35px] justify-start items-center gap-3 flex">
                        <div className="w-full xl:w-[155px] h-auto xl:h-[35px] px-5 py-2.5 justify-start items-center gap-4 flex">
                            <a href="https://ruscomtech.ru/static/docs/license-agreement-with-end-user.pdf" target="_blank" className="w-full xl:w-[155px] h-auto xl:h-[35px] px-5 py-2.5 bg-white/20 rounded-[20px] border border-white justify-center items-center gap-2.5 flex">
                                <div className="text-white text-[10px] lg:text-base font-bold font-['Open Sans']">Скачать</div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutAction;